<template>
  <!-- 案件詳細 -->
  <div id="CpapInstrumentRequestDetail">
    <div id="item-contens">
      <div class="card-content margin-top" v-if="showRequestInfo">
        <!--<span style="font-size:20px;">申込み情報</span>-->
        <table>
        <tr><th>申込日時</th><td>{{data.applicationDate}} {{data.applicationTime}}  {{data.applicationUserName}}</td></tr>
        <tr><th>受付番号</th><td>{{data.receiptNumber}}</td></tr>
        <!-- 案件詳細で表示
        <tr><th>見積コード</th>
          <td>{{data.quotationNumber}}</td>
        </tr>
        <tr><th>申込み状況</th>
          <td>
          <span class="tag is-success" style="height:30px;margin-left:5px;width:20%;">
            登録
          </span>
          </td>
          </tr>
        -->
        </table>
      </div>
      <div class="card-content margin-top">
        <span style="font-size:20px;">基本情報</span>
          <table>
          <tr><th>医療機関名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.hospitalName}}</td></tr>
          <tr><th>医師名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.doctorName}}</td></tr>
          <tr><th>事務担当者名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.clerkName}}</td></tr>
          <tr><th>機種</th><td>{{data.instrument}}</td></tr>
          <tr><th>台数</th><td>{{data.count}}</td></tr>
          <tr><th>加温加湿器</th><td>あり</td></tr>
          <tr><th>通信モジュール</th><td>なし</td></tr>
          <tr><th>【マスク】</th></tr>
          <tr><th>個数</th><td></td></tr>
          <tr><th>種類</th><td></td></tr>
          <tr><th>フレームサイズ</th><td></td></tr>
          <tr><th>クッションサイズ</th><td></td></tr>
          <tr><th>【機器納品先】</th></tr>
          <tr><th>住所</th><td>{{data.address}}</td></tr>
          <tr><th>宛名</th><td>{{data.receiverName}}</td></tr>
          <tr><th>連絡先(電話番号)</th><td>{{data.phone}}</td></tr>
          <tr><th>発送</th><td><b-checkbox class="cstmCheckBox" value="true" disabled></b-checkbox>川越から直送する</td></tr>
          </table>
      </div>
      <div class="card-content margin-top" v-if="showRequestMemo">
        <span style="font-size:20px;">その他</span>
        <table>
        <tr>
            <th>備考</th>
            <td>注意事項注意事項注意事項注意事項注意事項注意事項注意事項注意事項注意事項</td>
        </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";

export default {
  name: "CpapInstrumentRequestDetail",
  props:
  {
    data:{},
    showRequestInfo:{default:false},
    showRequestMemo:{default:true},
  },
  methods: {},
  data() {
    return {
    };
  },
  components: {},
  filters: {},
  mounted: function() {}
};
</script>


// WEBPACK FOOTER //
// src/components/mock/common/CpapInstrumentRequestDetail.vue